module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "banner-schedule-expired-icon.94dd3995.svg";